import { shopsActionTypes } from './shopActionTypes';

const { LIST_SHOP, FILTER_SHOP_NAME } = shopsActionTypes;

export const Shoplist = (plants) => {
	return {
		type: LIST_SHOP,
		payload: plants,
	};
};

export const filterShopName = (ShopName) => {
	return {
		type: FILTER_SHOP_NAME,
		payload: ShopName,
	};
};
